/**
 * AssetDrawerTabs Component
 *
 * Displays the tab navigation for the asset drawer.
 * Pure presentation component - all state management handled by parent.
 *
 * Uses local state pattern (via useAssetDrawerTab) to prevent tab alternation
 * bug caused by React Router setSearchParams race conditions during rapid
 * arrow key navigation.
 */

import { TabOption } from '@praetorian-chariot/ui';

import TabsComponent from '@/components/Tabs';

export interface AssetDrawerTabsProps {
  assetTabOptions: TabOption[];
  entityGroup: string;
  /** Current tab value from local state */
  currentTab: string;
  /** Tab change handler from local state hook */
  onTabChange: (tab: string) => void;
}

/**
 * AssetDrawerTabs renders the tab navigation system for asset details:
 * - Overview, Vulnerabilities, Attributes, Notes, History tabs
 * - Keyboard navigation with empty dependencies (tabs stable across row navigation)
 * - Uses local state pattern to prevent race conditions
 *
 * This is a pure presentation component with no internal state.
 */
export function AssetDrawerTabs({
  assetTabOptions,
  entityGroup: _entityGroup,
  currentTab,
  onTabChange,
}: AssetDrawerTabsProps) {
  return (
    <div className="-mt-4">
      <TabsComponent
        id="assetDetailsTabs"
        keyboardDependencies={[]}
        tabs={assetTabOptions}
        selected={
          assetTabOptions.find(tab => tab.value === currentTab) ||
          assetTabOptions[0]
        }
        onSelect={tabOption => {
          onTabChange(tabOption.value);
        }}
      />
    </div>
  );
}
